import { inject, observer } from 'mobx-react';
import * as React from 'react';
import citiesIcon from '../icons/cities.svg';
import countriesIcon from '../icons/countries.svg';
import speakersIcon from '../icons/speakers.svg';
import viewsIcon from '../icons/views.svg';
import { SpeechesData } from '../stores';
import { StatsElement } from './StatsElement';
import styles from './Talks.styl';

@inject('speeches')
@observer
export class Stats extends React.Component<{ speeches?: SpeechesData }> {
    render() {
        const { speeches } = this.props;
        return (
            <div className={styles.stats}>
                <StatsElement value={speeches.speakers.length} icon={speakersIcon} label="speakers"/>
                <StatsElement value={speeches.countries.length} icon={countriesIcon} label="countries"/>
                <StatsElement value={speeches.locations.length} icon={citiesIcon} label="cities"/>
                <StatsElement value={speeches.viewCount} icon={viewsIcon} label="views"/>
            </div>
        );
    }
}
